import { render } from "./BlogCatalogSearch.vue?vue&type=template&id=b6c4e43c&ts=true&lang=pug"
import script from "./BlogCatalogSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./BlogCatalogSearch.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__